<template>
  <AuthWrapper :title="$t('title.setNewPassword')">
    <template #top>
      <AuthBackToLogin/>
    </template>
    <ResetPasswordForm/>
  </AuthWrapper>
</template>

<script>
import AuthBackToLogin from 'common/components/AuthBackToLogin';
import AuthWrapper from 'common/components/auth/AuthWrapper';
import ResetPasswordForm from 'common/components/auth/ResetPasswordForm';

export default {
  name: 'ResetPasswordPage',
  components: {
    AuthBackToLogin,
    ResetPasswordForm,
    AuthWrapper,
  },
};
</script>
